<div
  dropdown
  placement="bottom right"
  container="body"
  [matTooltipDisabled]="asButton"
  [matTooltip]="sslStatus?.error || sslStatus?.label"
  [isDisabled]="1 | isReadonlyRole"
>
  <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
    <ng-container *ngIf="asButton">
      <button
        class="btn dropdown-toggle"
        [disabled]="disabled"
        [ngClass]="'btn-outline-' + sslStatus?.color"
        type="button"
      >
        <ng-template [ngTemplateOutlet]="sslIcon"></ng-template>
        <ng-container> {{ sslStatus?.label || 'Domain SSL' }}</ng-container>
      </button>
    </ng-container>
    <ng-container *ngIf="!asButton">
      <button type="button" class="btn" [ngClass]="'btn-light-' + sslStatus?.color">
        <ng-template [ngTemplateOutlet]="sslIcon"></ng-template>
      </button>
    </ng-container>
  </div>

  <ng-template #sslIcon>
    <i *ngIf="sslStatus?.status === 'active'" class="fas fa-shield-check"></i>
    <i *ngIf="sslStatus?.status === 'off'" class="far fa-shield-slash"></i>
    <i *ngIf="sslStatus?.status === 'custom'" class="far fa-user-shield"></i>
    <i *ngIf="sslStatus?.status === 'pending'" class="far fa-shield-check"></i>
    <i *ngIf="sslStatus?.status === 'error'" class="far fa-shield-xmark"></i>
  </ng-template>

  <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
    <li *ngIf="sslStatus?.status === 'pending'">
      <button (click)="doRefresh(false)" type="button">
        <i class="far fa-sync"></i><ng-container i18n>Refresh Status</ng-container>
      </button>
    </li>
    <li *ngIf="sslStatus?.status === 'off' || sslStatus?.status === 'error'">
      <button (click)="openRequestCertificateConfirm()" type="button">
        <i class="far fa-shield-check"></i>
        <ng-container *ngIf="sslStatus?.status === 'error'" i18n>Request SSL Certificate Again</ng-container>
        <ng-container *ngIf="sslStatus?.status !== 'error'" i18n>Request SSL Certificate</ng-container>
      </button>
    </li>
    <li *ngIf="sslStatus?.status === 'active'">
      <button (click)="openSslCertificateDialog()" type="button">
        <i class="far fa-eye"></i><ng-container i18n>View Certificate</ng-container>
      </button>
    </li>
    <li *ngIf="sslStatus?.status !== 'pending' && sslStatus?.status !== 'active'">
      <button (click)="openSslCertificateDialog()" type="button">
        <i class="far fa-user-shield"></i><ng-container i18n>Custom SSL Certification</ng-container>
      </button>
    </li>
    <li *ngIf="sslStatus?.status === 'active' || sslStatus?.status === 'custom'">
      <button (click)="openDeleteCertificateConfirm()" type="button">
        <i class="far fa-times"></i><ng-container i18n>Turn Off SSL</ng-container>
      </button>
    </li>
  </ul>
</div>
